import React from "react";
import { ClockIcon } from "./icons";

const toneStyles = {
  soon: "bg-[#FCE0A6] text-[#8A6B00]",
  live: "border border-green-500 text-green-600 bg-white",
  ended: "bg-gray-100 text-gray-500",
  upcoming: "bg-[#E6F2F0] text-[#0F4146]",
};

// Cash Game pills, per the client's own colour call on the League Play hero:
//
//   "The pill is our gold (#d7c588), and the font is dark teal (#004c50)."
//   "Change the Upcoming pill to have a neutral light gray background and dark
//    teal text (#004c50)."
//
// A SEPARATE map rather than new values in `toneStyles`, because that map is
// shared by every league preview on the site — the Public Leagues rows, the My
// Leagues tiles, the private invite card. Repainting `soon` gold there would
// change screens the client did not ask about; this is a Cash Game instruction,
// so only the Cash Game surfaces read it.
//
// `live` and `ended` are deliberately absent and fall through to the shared
// values: the client's note covers the gold Starting Soon pill and the neutral
// Upcoming pill only, and "all the other colors should match our changes" refers
// to the rest of the hero card, not to re-tinting Live.
const cashToneStyles = {
  soon: "bg-[#D7C588] text-[#004C50]",
  upcoming: "bg-[#F3F4F6] text-[#004C50]",
};

const StatusPill = ({ status, withIcon = true, variant = "default" }) => {
  if (!status) return null;
  const palette =
    variant === "cash" ? { ...toneStyles, ...cashToneStyles } : toneStyles;
  const cls = palette[status.tone] || palette.upcoming;
  const isLive = status.tone === "live";
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium whitespace-nowrap ${cls}`}
    >
      {isLive ? (
        <span className="inline-block w-2 h-2 rounded-full bg-green-500" />
      ) : (
        withIcon && status.tone === "soon" && <ClockIcon className="w-3.5 h-3.5" />
      )}
      {status.label}
    </span>
  );
};

export default StatusPill;
